import React from 'react';
import ReactDOM from 'react-dom';
import App from './App.js';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/js/bootstrap.js';
import './main.scss'

import * as serviceWorker from './serviceWorker';
import "typeface-montserrat";
import './fonts/DejaVuSerif/DejaVuSerif.ttf'
import './fonts/DejaVuSerif/DejaVuSerif-Bold.ttf'
import './fonts/Roboto/Roboto-Regular.ttf'
import { createStore, combineReducers } from "redux";
import { Provider } from "react-redux";

import user from './store.js'
import adminClient from './Admin/components/Client/store.js'
import provider from './Admin/components/Provider/store.js'
import codeBook from './Admin/components/CodeBook/store.js'
import report from './Admin/components/Import/store'
import transaction from './Admin/components/Transaction/store'
import dashboard from './Admin/components/DashBoard/store'

import i18n from './i18n/i18n';
import { I18nextProvider } from 'react-i18next'

const rootReducer = combineReducers({
	user: user,
    adminClient: adminClient,
    provider: provider,
    codeBook: codeBook,
    report: report,
    transaction: transaction,
    dashboard: dashboard
});

const store = createStore(rootReducer);

ReactDOM.render(
    <I18nextProvider i18n={i18n}>
        <Provider store={store}>
            <App />
        </Provider>
    </I18nextProvider>,

	document.getElementById('root')
);

serviceWorker.unregister();